import {Component, inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ExpertiseService, IExpertiseDoc, IUpdateExpertise} from "../../../../shared/services/expertise.service";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs/internal/operators/finalize";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-status-confirm-dialog',
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.6358 27.6267H19.1111L18.8368 12.1601H22.9312L22.6358 27.6267Z" fill="white"/>
          <path
            d="M21 35.36C22.2764 35.36 23.3111 34.3213 23.3111 33.04C23.3111 31.7587 22.2764 30.72 21 30.72C19.7236 30.72 18.6889 31.7587 18.6889 33.04C18.6889 34.3213 19.7236 35.36 21 35.36Z"
            fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M22.3618 0.823182C21.7831 -0.274395 20.2169 -0.274394 19.6382 0.823183L0.181062 37.7299C-0.36199 38.7599 0.381872 40 1.54281 40H40.4572C41.6181 40 42.362 38.7599 41.8189 37.7299L22.3618 0.823182ZM21 4.85313L4.10138 36.9067H37.8986L21 4.85313Z"
                fill="white"/>
        </svg>

        <span class="dialog-title">Внимание!</span>

        <div class="dialog-close" matDialogClose>✕</div>

      </div>

      <div class="dialog-body">
        <p class="confirm-message" [class.active]="!data.isActive">

          <ng-container *ngIf="data.isActive; else notActive">
            Подтвердите, что данная экспертиза становится бездействующей.
          </ng-container>

          <ng-template #notActive>
            Подтвердите, что данная экспертиза становится действующей.
          </ng-template>

        </p>
        <p class="description">

          <ng-container *ngIf="data.isActive; else notActive2">
            Ресурсы по сметам этой экспертизы не будут выгружаться на сайт material.kz
          </ng-container>
          <ng-template #notActive2>
            По действующей экспертизе будет произведен парсинг файлов смет kenml и ресурсы будут
            выгружены на сайт material.kz
          </ng-template>
        </p>
      </div>

      <div class="dialog-actions">
        <button *ngIf="!loading" matRipple class="btn btn-apply" (click)="onClose()">Ок</button>
        <button *ngIf="loading" class="btn btn-cancel">
          <div class="loading"></div>
        </button>
        <button matRipple class="btn btn-cancel" matDialogClose>Отмена</button>
      </div>
    </div>

  `,
  styles: [`
    .dialog-container {
      width: 100%;
      max-width: 500px;

      .dialog-header {
        display: flex;
        align-items: center;
        background-color: #d32f2f;
        color: white;
        padding: 10px 16px;
        position: relative;
        justify-content: space-between;

        .dialog-title {
          font-size: 25px;
          margin-left: 8px;
        }

        .dialog-close {
          cursor: pointer;
        }

        button {
          position: absolute;
          right: 8px;
          top: 4px;
          color: white;
        }
      }

      .dialog-body {
        padding: 20px;

        .confirm-message {
          color: rgba(215, 2, 2, 1);
          font-weight: bold;
          text-align: center;
          font-size: 22px;

          &.active {
            color: rgba(60, 177, 64, 1);
          }
        }

        .description {
          margin-top: 12px;
          color: #555;
          text-align: center;
          font-size: 18px;
          color: rgba(76, 83, 98, 1);
        }
      }

      .dialog-actions {
        display: flex;
        justify-content: center;
        padding: 16px 0;
        border: 1px solid rgba(210, 210, 210, 1);

        button {
          border: none;
        }
      }
    }

  `]
})
export class StatusConfirmDialogComponent {
  readonly dialogRef = inject(MatDialogRef<StatusConfirmDialogComponent>);
  readonly data = inject<{
    isActive: boolean,
    expertise: IExpertiseDoc,
    livingComplexID: number,
    regionID: number
  }>(MAT_DIALOG_DATA);
  private service = inject(ExpertiseService);
  private toastr = inject(ToastrService);


  loading = false;

  onClose() {
    this.loading = true;
    const expertiseToUpdate: IUpdateExpertise = {
      documentDate: this.data.expertise.date,
      documentNumber: this.data.expertise.number,
      expertiseID: this.data.expertise.id,
      expertiseType: this.data.expertise.expertiseType,
      isIntegration: this.data.expertise.isIntegration,
      isActive: !this.data.isActive,
      livingComplexID: this.data.livingComplexID,
      regionID: this.data.regionID
    }
    this.service.updateExpertise(expertiseToUpdate)
      .pipe(
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (res) => {
          console.log(res);
          this.toastr.success('Успешно обновлено!')
          this.dialogRef.close(!this.data.isActive);

        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error('Ошибка!', err.error.message)
        }
      })
  }

}
